import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchAuthenticatorStatus, fetchProfile, saveProfile, uploadAvatar, type ProfileDetail } from '../api/profile'
import { queryKeys } from '../api/queryKeys'

export function useProfile() {
  return useQuery({
    queryKey: queryKeys.profile.detail(),
    queryFn: fetchProfile,
  })
}

export function useAuthenticatorStatus() {
  return useQuery({
    queryKey: queryKeys.profile.authenticator(),
    queryFn: fetchAuthenticatorStatus,
  })
}

export function useUpdateProfileMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (values: ProfileDetail) => saveProfile(values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.profile.detail() })
    },
  })
}
export function useUploadAvatarMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: { file: File; isMale: boolean }) => uploadAvatar(input),
    onSuccess: () => {
      // Avatar is read back through the combined user-media query.
      queryClient.invalidateQueries({ queryKey: queryKeys.advisory.media() })
    },
  })
}
